import { Component, EventEmitter, Output, Inject, OnDestroy } from '@angular/core';
import { OnInit } from "@angular/core";
import { Router, NavigationEnd, RouterEvent } from "@angular/router";
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';
import { Subject, Subscription, EMPTY } from 'rxjs';

import { config } from "../../../../../../config/index";

import { SharedService } from "../../../services/shared.service";
import { SessionStorageService } from '../../../services/session-storage.service';
import { SnackbarService } from "../../../../shared/services/snackbar.service";


@Component({
    selector: 'settings-menu',
    template: require('./settings-menu.component.html'),
    styles: [require('./settings-menu.component.less')],
    providers: [SharedService, SessionStorageService, SnackbarService],
    preserveWhitespaces: true
})

export class SettingsMenuComponent implements OnInit, OnDestroy {

    @Output() settingsMenuEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() optionDataEvent: EventEmitter<any> = new EventEmitter<any>();


    groupList: any[] = [];
    private _role = config.role;
    private _userRole: string;
    private locatManager: string;
    private cooAdmin: string;
    private ctAdmin: string;
    practicePackage: any;
    settingsMenuSearchKey: any
    isAusPractice: boolean;

    searchInputSub$: Subject<string> = new Subject<string>();
    searchInputSubscription: Subscription;
    getTreatmentOptionsSubscription: Subscription;

    urlsWithSearch: Array<string> = [
        '/pa-settings/geography-settings',
        '/pa-settings/set-goals',
        '/pa-settings/referral-source',
        '/patient-payment-details',
        '/ct-settings/ct-category',
        '/ct-settings/additional-appliance-options',
        '/ct-settings/insurance-plan-management',
        '/ct-settings/ct-promocode',
        '/ct-settings/referral-source-management',
        '/ct-settings/retainer-program-management'
    ];
    canShowSearch: boolean;

    constructor(
        private _sharedService: SharedService,
        private _sessionStorageService: SessionStorageService,
        private _mdlSnackbarService: SnackbarService,
        private _router: Router,
        @Inject('utilService') private utilService: any
    ) {
        _router.events.subscribe(
            (event: RouterEvent): void => {
                if (this.urlsWithSearch.includes(event.url)) {
                    this.canShowSearch = true;
                }
                if ( event instanceof NavigationEnd ) {
                    setTimeout(() => {
                        const selectedEle = document.querySelector('.menu.selected');
                        const menuEle = document.getElementsByClassName('settings-menu');

                        if (selectedEle && menuEle[0]) {
                            menuEle[0].scrollTop = selectedEle['offsetTop'];
                        }
                    }, 500);
                }
            });
    }

    /** Fetching user role **/
    userRoleFetch = () => {
        this._sessionStorageService.readItem(this._role).then((data: any) => {
            this._userRole = data.role;
            if (this._userRole === this.cooAdmin) {
                this.checkPracticeCountry();
            }
        });
    }

    /**
     * function to fetch and check whether the practice country is Australia
     */
    checkPracticeCountry() {
        this._sessionStorageService.readItem('practice_country_key').then((data: any) => {
            this.isAusPractice = (data === 'AU');
        });
    }

    /* Treatment Options */
    getTreatmentOptions = () => {
        this.getTreatmentOptionsSubscription?.unsubscribe();
        this.getTreatmentOptionsSubscription = this._sharedService.getTreatmentOptions()
            .subscribe((res: any) => {
                this.groupList = res.data;
                for (let i in this.groupList) {
                    if (this.groupList[i].is_limited) {
                        this.groupList[i].newName = 'Limited' + this.groupList[i].name.replace(/\s/g, ''); // name without white space
                    } else {
                        this.groupList[i].newName = this.groupList[i].name.replace(/\s/g, ''); // name without white space
                    }
                }
                this.optionDataEvent.emit(this.groupList);
            },
            error => this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error'));
    }

    /* Save Group ID to local storage */
    saveGroupToLocal = (option: any, event: any) => {
        event.stopPropagation();
        this._sessionStorageService.saveItem('groupId', option).then(
            (data: any) => {
                this.optionDataEvent.emit(this.groupList);
                this._router.navigate(['pa-settings/pricing/' + option.newName]);
            }
        );
    }

    navigate = (path: any) => {
        if (path === 'contracts/all' || path === 'subscription' || path === 'change-password') {
            this._router.navigate([path]);
        } else if (this._userRole == this.cooAdmin || this._userRole == this.locatManager) {
            this._router.navigate(['pa-settings/' +path]);
        } else if (this._userRole == this.ctAdmin) {
            this._router.navigate(['ct-settings/' + path]);
        }
    }

    searchItem = () => {
        this.settingsMenuEvent.emit(this.settingsMenuSearchKey);
    }

    ngOnInit() {
        this._sessionStorageService.readItem(config.package).then(
            (data: any) => this.practicePackage = data.package
        )
        this.getTreatmentOptions();
        this.locatManager = config.location_manager;
        this.cooAdmin = config.coo_admin;
        this.ctAdmin = config.ct_admin;
        this.userRoleFetch();
        this.utilService.hideHeaderNavDropDownNotSubscribed.next({ opened: true });

        // add delay for searching on typing
        this.searchInputSubscription = this.searchInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(() => {
                this.searchItem();
                return EMPTY;
            })
        ).subscribe();
    }

    ngOnDestroy() {
        this.utilService.hideHeaderNavDropDownNotSubscribed.next({ opened: false });
        this.searchInputSubscription?.unsubscribe();
        this.getTreatmentOptionsSubscription?.unsubscribe();
    }
}

